import styles from "./button.module.scss";

export default function CamelotButton(props:{text:string, action?: (e: any) => unknown; ghost?: boolean, secondary?: boolean, disabled?: boolean, width?: string, green?: boolean}){
    return(
        <button style={{width: props.width}} className={props.green ? styles.greenButton : props.secondary? styles.secondaryButton : props.ghost? styles.ghostButton : styles.mainButton} disabled={props.disabled} onClick={async (e) => props.action && props.action(e)}>{props.text.toUpperCase()}</button>
    )
}